import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAnalytics } from '../hooks/useAnalytics';

const AuthWall = ({ isOpen, onClose, feature = 'content', message }) => {
  const navigate = useNavigate();
  const { trackEvent } = useAnalytics();

  if (!isOpen) return null;

  const handleSignUp = () => {
    trackEvent('auth_wall_triggered', { feature, action: 'signup_clicked' });
    navigate('/auth?mode=signup');
    onClose();
  };

  const handleLogIn = () => {
    trackEvent('auth_wall_triggered', { feature, action: 'login_clicked' });
    navigate('/auth?mode=login');
    onClose();
  };

  const defaultMessage = feature === 'storyverse_original'
    ? 'Sign up to watch Storyverse Originals'
    : feature === 'create'
    ? 'Sign up to create your own stories'
    : 'Sign up to continue';

  const FREDOKA = { fontFamily: "'Fredoka', sans-serif" };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 animate-fade-in"
      style={{ background: "rgba(11,26,51,0.45)", backdropFilter: "blur(6px)" }}
      onClick={onClose}
    >
      <div
        className="relative w-full max-w-md animate-slide-up"
        style={{
          ...FREDOKA,
          background: "#FFFFFF",
          borderRadius: 28,
          padding: "38px 28px 28px",
          border: "1px solid rgba(11,26,51,0.06)",
          boxShadow: "0 24px 60px rgba(11,26,51,0.28), 0px 2px 0px rgba(11,26,51,0.05)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close button */}
        <button
          onClick={onClose}
          aria-label="Close"
          className="absolute top-4 right-4 transition active:scale-90"
          style={{ color: "#8CA0BC" }}
        >
          <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth={2.4} viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        {/* Lock Icon */}
        <div className="flex justify-center mb-6">
          <div
            className="flex items-center justify-center"
            style={{
              width: 76,
              height: 76,
              borderRadius: "50%",
              background: "linear-gradient(135deg, #0A7DFF 0%, #0065F8 55%, #00CAFF 100%)",
              boxShadow: "0 10px 24px rgba(0,101,248,0.35), inset 0 1px 0 rgba(255,255,255,0.4)",
            }}
          >
            <svg width="36" height="36" fill="none" stroke="#fff" strokeWidth={2} viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
              />
            </svg>
          </div>
        </div>

        {/* Message */}
        <h2 className="text-center" style={{ ...FREDOKA, color: "#0B1A33", fontWeight: 700, fontSize: 26, lineHeight: 1.15, margin: "0 0 10px" }}>
          {message || defaultMessage}
        </h2>
        <p className="text-center" style={{ ...FREDOKA, color: "#5A6B85", fontSize: 15, lineHeight: 1.5, margin: "0 0 26px" }}>
          Join Pixley to unlock exclusive content and create your own characters and stories
        </p>

        {/* Buttons */}
        <button
          onClick={handleSignUp}
          className="w-full transition active:translate-y-px"
          style={{
            ...FREDOKA,
            background: "linear-gradient(180deg, #0A7DFF 0%, #0065F8 100%)",
            color: "#FFFFFF",
            fontWeight: 700,
            fontSize: 16,
            border: "1px solid rgba(255,255,255,0.5)",
            borderRadius: 16,
            padding: "15px 20px",
            marginBottom: 12,
            cursor: "pointer",
            boxShadow: "inset 0 1px 0 rgba(255,255,255,0.4), 0px 4px 0px #073B8E, 0px 10px 22px rgba(0,101,248,0.28)",
          }}
        >
          Create Free Account
        </button>

        <button
          onClick={handleLogIn}
          className="w-full transition active:translate-y-px"
          style={{
            ...FREDOKA,
            background: "#FFFFFF",
            color: "#0065F8",
            fontWeight: 700,
            fontSize: 16,
            border: "2px solid rgba(0,101,248,0.22)",
            borderRadius: 16,
            padding: "14px 20px",
            cursor: "pointer",
            boxShadow: "0px 2px 0px rgba(11,26,51,0.05)",
          }}
        >
          Log In
        </button>
      </div>
    </div>
  );
};

export default AuthWall;
